import type {InsightTargetPeriodV4 as InsightTargetPeriodApi} from "../../models/crm-v4";

export const CRM_BUDGETS_TABLE_ID = "crm-insight-budgets";

export interface InsightTargetPeriod {
    id: string;
    name?: string;
    from: string;
    to: string;
    active: boolean;
    targets: Record<string, number>;
}

/** Adds the view-only row id used by the target manager. */
export function targetRows(periods: InsightTargetPeriodApi[] | undefined): InsightTargetPeriod[] {
    return (periods ?? []).map(period => ({
        id: `${period.from}:${period.to}`,
        name: period.name,
        from: period.from,
        to: period.to,
        active: period.active,
        targets: period.targets,
    })).sort((left, right) => left.from.localeCompare(right.from));
}
